import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AdSession {
    pageViewCount: number;
    sessionStartDateISO: string;
}

export interface AdsReduxState {
    session?: AdSession;
}

const initialState = {} as AdsReduxState;

const adsSlice = createSlice({
    name: 'ads',
    initialState,
    reducers: {
        setAdSession: (state, action: PayloadAction<AdSession>) => {
            state.session = action.payload;
        },
    },
});

export const { setAdSession } = adsSlice.actions;
export default adsSlice.reducer;
